import { HttpParams } from '@angular/common/http';
import * as qs from 'qs';

export function getParams(params: any): HttpParams {
	if (!params) return undefined;

	return new HttpParams({ fromString: qs.stringify(params, { allowDots: true, skipNulls: true }) });
}



export type AttendeeAnswer = {
  dietaryPreference?: string;
  type: string;
  request?: string;
};

const DEFAULT_PREFERENCE_LABELS: { [key: string]: string } = {
  VEGAN: 'Vegan',
  VEGETARIAN: 'Vegetarian',
  GLUTEN_FREE: 'Gluten Free',
};

function capitalize(value: string): string {
  if (!value) return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function formatDietaryPreferenceCounts(
  answers: AttendeeAnswer[] = [],
  preferenceLabels: { [key: string]: string } = DEFAULT_PREFERENCE_LABELS
): string[] {
  const counts: { [key: string]: number } = {};

  for (let i = 0; i < answers.length; i++) {
    const item = answers[i];
    const dietaryPreference = item.dietaryPreference;
    const type = item.type;

    if (!dietaryPreference) continue;

    const key = dietaryPreference + '_' + type;
    counts[key] = (counts[key] || 0) + 1;
  }

  const result: string[] = [];

  const keys = Object.keys(counts);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const count = counts[key];

    const lastUnderscore = key.lastIndexOf('_');
    const diet = key.substring(0, lastUnderscore);
    const type = key.substring(lastUnderscore + 1);

    const label =
      preferenceLabels[diet] ||
      capitalize(diet.toLowerCase().replace(/_/g, ' '));

    result.push(label + ' X ' + count + ' (' + type + ')');
  }

  return result;
}


interface FormatAttendeeResult {
  attendeeRequests: string[];
}

export function formattedAttendeeAllergy(
  answers: AttendeeAnswer[]
): FormatAttendeeResult {
  const counts: Record<string, number> = {};
  const attendeeRequests: string[] = [];

  let adultCount = 1;
  let childCount = 1;

  for (const item of answers) {
    const { dietaryPreference, type, request } = item;

    // Count dietary preferences
    if (dietaryPreference) {
      const key = `${dietaryPreference}_${type}`;
      counts[key] = (counts[key] || 0) + 1;
    }

    // Collect special requests
    if (request) {
      if (type === 'ADULT') {
        attendeeRequests.push(`(${type} ${adultCount}) ${request}`);
        adultCount++;
      } else if (type === 'CHILD') {
        attendeeRequests.push(`(${type} ${childCount}) ${request}`);
        childCount++;
      }
    }
  }

  return {attendeeRequests};
}